@if (isOpen) {
<div class="fixed inset-0 z-1000 flex items-center justify-center bg-gray-400/60 p-4" aria-labelledby="modal-title"
  role="dialog" aria-modal="true">
  <!-- Modal Panel -->
  <div
    class="relative w-full max-w-md overflow-hidden rounded-xl bg-white shadow-xl ring-1 ring-black/10 flex flex-col items-center py-6 px-6">

    <div class="flex items-center justify-center mb-4">
      <div [class]="'flex h-12 w-12 items-center justify-center rounded-full bg-green-100'">
        @if (type === 'success') {
        <svg class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
        </svg>
        }

        @if (type === 'error') {
        <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
        }
        @if (type === 'warning') {
        <svg class="h-6 w-6 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
        }
        @if (type === 'info') {
        <svg class="h-6 w-6 text-blue-500" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
        </svg>
        }
      </div>
    </div>

    <h3 class="text-lg font-semibold text-gray-900 text-center mb-1" id="modal-title">{{ title }}</h3>
    <p class="text-sm text-gray-500 text-center mb-5">{{ message }}</p>

    <button type="button" (click)="onClose()"
      class="w-full rounded-md bg-indigo-600 py-2 text-base font-medium text-white shadow hover:bg-indigo-700 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer">
      Aceptar
    </button>
  </div>
</div>
}